module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('b', [_vm._v("SAVAGE ARENA")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("A cry from the stands alerted the peasant to the entry of two hunters into the arena. They were dressed in the pelts of the "), _c('i', [_vm._v("hanis")]), _vm._v(", indigenous to the savannahs of Lysis. Each carried a net in his left hand, a spear in the right. In their belts were poisoned darts, like tiny, finned javelins. They spread out, one to each side of the peasant.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("He turned suddenly, charged the man to his right. One blow of the "), _c('i', [_vm._v("barang")]), _vm._v(" snapped the spear, the second took the hunter’s arm off at the shoulder. The peasant spun, cut the second hunter’s flung net in twain, grabbed the thrust spear and jerked the hunter toward him, unto the point of the "), _c('i', [_vm._v("barang")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("The peasant went to stand by the carcass of the vi-cat. He looked up to the now silent stands.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("There was a blast of trumpets, and from the gate of the fighters strode forth two gladiators. These men were matched, trained fighters. It was not likely that one would die…")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f307d7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section1.vue
// module id = 66
// module chunks = 0